import { render } from "./BrandDropDown.vue?vue&type=template&id=619af2e9"
import script from "./BrandDropDown.vue?vue&type=script&lang=js"
export * from "./BrandDropDown.vue?vue&type=script&lang=js"
script.render = render

export default script